import React from 'react';

const ProgressCell = ({ progress }) => <span>{`${progress.toFixed(1)}%`}</span>;

export default ProgressCell;
